 <!-- <mat-toolbar class="toolbar-example">
    <span> Auto Panel Creation </span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<table style="padding-left: 60%">
    <tr>
      <td> &#x267C; Total Shortlisted Candidates:</td>
      <td><b>{{totalAvailableCandidate}}</b></td>
    </tr>

    <tr>
      <td> &#x267C; Total PanelMembers Available:</td>
      <td><b>{{totalAvailablePanelMember}}</b></td>
    </tr>
</table>

<form [formGroup]="service.form" class="normal-form" > -----------(submit)='onSubmit()'----------
    <mat-grid-list cols="1" rowHeight="250px">
        <mat-grid-tile>
            <div class="controles-container">
                <input type="hidden" formControlName="id">
                
                <mat-form-field>
                    <input type="number" formControlName="panelCnt" matInput placeholder="No. of Panels ?" [(ngModel)]="data.noOfPanels">
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.required">This field is required
                    </mat-error>
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.minLength">Minimum 1 digit number is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input type="number" formControlName="candidateCntPerPanel" matInput placeholder="No. of Candiadates per Panel ?">
                    <mat-error *ngIf="service.form.controls['candidateCntPerPanel'].errors?.required">This field is required</mat-error>
                    <mat-error *ngIf="service.form.controls['candidateCntPerPanel'].errors?.minLength">Minimum 1 number is required</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input type="number" formControlName="panelMemberCntPerPanel" matInput placeholder="No. of Panel Members per Panel ?">
                    <mat-error *ngIf="service.form.controls['panelMemberCntPerPanel'].errors?.required">This field is required
                    </mat-error>
                    <mat-error *ngIf="service.form.controls['panelMemberCntPerPanel'].errors?.minLength">Minimum 1 digit number is required
                    </mat-error>
                </mat-form-field>

                --------------- <mat-form-field>
                    <input type="number" formControlName="panelCnt" matInput placeholder="No. of Panels ?">
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.required">This field is required
                    </mat-error>
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.minLength">Minimum 1 digit Number is required
                    </mat-error>
                </mat-form-field> -----------------------

            </div>
        </mat-grid-tile>
    </mat-grid-list>
    <div class="button-row action-btn">
        <button mat-raised-button class="btn-color-example" type="submit" [disabled]="service.form.invalid" [mat-dialog-close]="data.noOfPanels" cdkFocusInitial>Create</button>
        <button mat-raised-button class="btn-clear btn-align" (click)='onClear()'>Clear</button>
    </div>
</form>  -->



<mat-toolbar class="toolbar-example">
    <span> Auto Room Creation </span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<table style="padding-left: 70%;  margin-top: 10px; padding-right: 15px;">
    <tr>
      <td>Total Shortlisted Candidates:</td>
      <td style="color: blue;"><b>{{totalAvailableCandidate}}</b></td>
    </tr>

    <tr>
      <td>Total PanelMembers Available:</td>
      <td style="color: blue;"><b>{{totalAvailablePanelMember}}</b></td>
    </tr>
</table>

<form [formGroup]="service.form" class="normal-form" (submit)='onSubmit()'>
    <mat-grid-list cols="1" rowHeight="300px">
        <mat-grid-tile>
            <div class="controles-container">
                <input type="hidden" formControlName="id">
                
                <mat-form-field>
                    <input type="number" formControlName="panelCnt" matInput placeholder="No. of Rooms">
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.required">This field is required
                    </mat-error>
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.minLength">Minimum 1 digit number is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input type="number" formControlName="candidateCntPerPanel" matInput placeholder="No. of Candidates per Room">
                    <mat-error *ngIf="service.form.controls['candidateCntPerPanel'].errors?.required">This field is required</mat-error>
                    <mat-error *ngIf="service.form.controls['candidateCntPerPanel'].errors?.minLength">Minimum 1 number is required</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input type="number" formControlName="panelMemberCntPerPanel" matInput placeholder="No. of Panel Members per Room">
                    <mat-error *ngIf="service.form.controls['panelMemberCntPerPanel'].errors?.required">This field is required
                    </mat-error>
                    <mat-error *ngIf="service.form.controls['panelMemberCntPerPanel'].errors?.minLength">Minimum 1 digit number is required
                    </mat-error>
                </mat-form-field>

                <!--------------------- <mat-form-field>
                    <input type="number" formControlName="panelCnt" matInput placeholder="No. of Panels ?">
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.required">This field is required
                    </mat-error>
                    <mat-error *ngIf="service.form.controls['panelCnt'].errors?.minLength">Minimum 1 digit Number is required
                    </mat-error>
                </mat-form-field> --------------->
                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                    <div>
                        Attach MOVIE Meeting Link &nbsp;&nbsp;&nbsp;
                        <mat-slide-toggle color="primary" class="meeting-link-attachment-toggle" checked="meetingLinkProvider !== null" (click)="toggleMeetingLinkAttachment()">
                        </mat-slide-toggle>
                    </div>
                    <mat-icon style="vertical-align: middle; cursor: pointer; color: #252c61;" title="MOVIE: Meetings & Interview Platform, Powered by MyAnatomy Integration Pvt Ltd">info</mat-icon>
                </div>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
    <div class="button-row action-btn">
        <button mat-raised-button class="btn-color-example" type="submit" [disabled]="service.form.invalid">Create</button>
        <button mat-raised-button class="btn-clear btn-align" (click)='onClear()'>Cancel</button>
    </div>
</form>